import axios from "axios";
import { getToken } from "./token";
import AUTH_TYPES from "redux/types/auth";
import errorHandler from "utils/errorHandler";
import { toast } from "react-hot-toast";

let baseURL = process.env.REACT_APP_API;
const api = axios.create({
  baseURL: baseURL,
});

export const setupInterceptors = (store, history) => {
  api.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
      config.timeout = 20000;
      config.timeoutErrorMessage = `O servidor demorou muito para responder. Tente novamente ou contate o suporte.`;
      return config;
    },
    (error) => Promise.reject(error)
  );

  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Verificar se o erro tem uma resposta do servidor antes de acessar status
      if (error.response && error.response.status === 401) {
        if (window.location.pathname !== `/login`) {
          store.dispatch({ type: AUTH_TYPES.LOGOUT });
          localStorage.clear();
          toast.error(errorHandler(error, true));
          history.push("/login");
        }
      }
      return Promise.reject(error);
    }
  );
};

export default api;
